import { ColorModeContext } from '@/assets/branding/CustomThemeProvider';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { type SimpleMenuItemProps } from './buttons/SimpleMenuItem';

export const useColorMode = (): SimpleMenuItemProps => {
  const toggleColorMode = useContext(ColorModeContext);
  const { mode } = useTheme();

  const modeIcon = mode === 'dark' ? LightModeOutlinedIcon : DarkModeOutlinedIcon;

  const modeLabel = mode === 'dark' ? 'Light Mode' : 'Dark Mode';

  const colorSchemaDataTestId = mode === 'dark' ? 'LightSchemaBtn' : 'DarkSchemaBtn';

  return {
    title: modeLabel,
    icon: modeIcon,
    testId: colorSchemaDataTestId,
    onClick: (): void => toggleColorMode()
  };
};
